/**
 * This script is used to randomize the banner content displayed on the homepage.
 * The banner content is available to this component via a data attribute on the
 * Homepage banner element.
 */

class HomepageBanner {
  constructor(config) {
    this.el = config.el;

    // Banner content is available as JSON in a data attribute
    this.banners = JSON.parse(this.el.getAttribute("data-content"));

    // Pick a random banner
    this.activeBanner = this.randomBanner();

    // Set image soruces and link
    this.setupBanner();
  }

  /**
   * Setup the active banner
   * Applies image sources and link content to the homepage banner based
   * on the randomly selected banner
   * @memberof HomepageBanner
   */
  setupBanner() {
    const $backgroundImage = this.el.querySelector(".EligibilityBanner-desktopImage");
    if ($backgroundImage) {
      $backgroundImage.setAttribute("src", this.activeBanner.background);
    }

    const $mobileImage = this.el.querySelector(".EligibilityBanner-mobileImage");
    if ($mobileImage) {
      $mobileImage.setAttribute("src", this.activeBanner.mobileBackground);
    }

    const $link = this.el.querySelector(".EligibilityBanner-footer-link");
    if ($link) {
      if (this.activeBanner.link.url && this.activeBanner.link.title) {
        $link.setAttribute("href", this.activeBanner.link.url);
        $link.innerText = this.activeBanner.link.title;
      } else {
        // if a link title and URL are not provided, remove the link
        $link.remove();
      }
    }

    // Add the -ready class to re-enable display of the images and link.
    // This is used in conjunction with the document .js class to prevent
    // a flash of the PHP rendered default/fallback banner until this script
    // has finished setting a random banner.
    this.el.classList.add("-ready");
  }

  /**
   * Pick a random banner
   * @returns {object}
   * @memberof HomepageBanner
   */
  randomBanner() {
    return this.banners[Math.floor(Math.random() * this.banners.length)];
  }
}

const init = () => {
  // Only instantiate this class on the homepage
  let homepageBanner = document.querySelector("#HomepageBanner");

  if (homepageBanner) {
    new HomepageBanner({ el: homepageBanner });
  }
};

// Init on initial page load
init();

